import React, { useState, useEffect } from "react";
import { Phone, MapPin, Calendar, Newspaper, Gift } from "lucide-react";
import RSVPForm from "./RSVPForm";
import PersonContact from "./PersonContact";
import EventLocation from "./EventLocation";
import EventCalendar from "./EventCalander";
import GiftSection from "./GiftSection";
import "../../CSS/musicplayer.css";
import "../../CSS/bottomNavBarCard.css";

const CardBottomNav = ({ data, contacts, gifts, source = 'firebase', uniqueCode, onGiftReserved }) => {
    const [active, setActive] = useState("");
    const [showRSVP, setShowRSVP] = useState(false);
    const [showPersonContact, setPersonContact] = useState(false);
    const [showLocation, setShowLocation] = useState(false);
    const [showCalendar, setCalendar] = useState(false);
    const [showQRBank, setQRBank] = useState(false);
    const [closing, setClosing] = useState(false);



    const handleSelect = (section) => {
        if (active === section) return; // if already active, do nothing

        // if something is open, close it first smoothly
        if (showRSVP || showPersonContact || showLocation || showCalendar || showQRBank) {
            setClosing(true);

            setTimeout(() => {
                // after animation ends, switch to new section
                setClosing(false);
                setShowRSVP(false);
                setPersonContact(false);
                setShowLocation(false);
                setCalendar(false);
                setQRBank(false);

                // small delay done → open new popup
                setActive(section);
                if (section === "rsvp") setShowRSVP(true);
                else if (section === "contact") setPersonContact(true);
                else if (section === "location") setShowLocation(true);
                else if (section === "calendar") setCalendar(true);
                else if (section === "gift") setQRBank(true);
            }, 150); // match CSS close duration
        } else {
            // nothing open, open directly
            setActive(section);
            if (section === "rsvp") setShowRSVP(true);
            else if (section === "contact") setPersonContact(true);
            else if (section === "location") setShowLocation(true);
            else if (section === "calendar") setCalendar(true);
            else if (section === "gift") setQRBank(true);
        }
    };

    const handleClose = () => {
        setClosing(true);
        setActive("");
        setTimeout(() => {
            setShowRSVP(false);
            setPersonContact(false);
            setShowLocation(false);
            setCalendar(false);
            setQRBank(false);
            setClosing(false);

        }, 150); // must match CSS animation duration
    };

    useEffect(() => {
        const handleOpenRSVP = () => {
            if (active === "rsvp") return;

            setClosing(false);
            setActive("rsvp");
            setShowRSVP(true);
            setPersonContact(false);
            setShowLocation(false);
            setCalendar(false);
        };

        window.addEventListener("open-rsvp", handleOpenRSVP);

        return () => {
            window.removeEventListener("open-rsvp", handleOpenRSVP);
        };
    }, [active]);



    return (
        <>
            <div className="card-bottom-nav" style={{ "--theme-color": data?.buttonColour || data?.themeColour }}>
                <button
                    className={`nav-btn ${active === "contact" ? "active" : ""}`}
                    onClick={() => handleSelect("contact")}

                >
                    <Phone size={20} />
                </button>
                <button
                    className={`nav-btn ${active === "location" ? "active" : ""}`}
                    onClick={() => handleSelect("location")}
                >
                    <MapPin size={20} />
                </button>
                <button
                    className={`nav-btn ${active === "calendar" ? "active" : ""}`}
                    onClick={() => handleSelect("calendar")}
                >
                    <Calendar size={20} />
                </button>
                <button
                    className={`nav-btn ${active === "rsvp" ? "active" : ""}`}
                    onClick={() => handleSelect("rsvp")}
                >
                    <Newspaper size={20} />
                </button>

                {(data.showQRBank || data.showWishlistGift) && (data.packageType === 'Premium' || data.package === 'Premium') && (
                    <button
                        className={`nav-btn ${active === "gift" ? "active" : ""}`}
                        onClick={() => handleSelect("gift")}
                    >
                        <Gift size={20} />
                    </button>
                )}
            </div>

            {showRSVP && (
                <>
                    <div className="rsvp-overlay" onClick={handleClose} />
                    <div className={`rsvp-popup ${closing ? "popup-close" : "popup-open"}`}>
                        <RSVPForm data={data} onClose={handleClose} source={source} uniqueCode={uniqueCode} />
                    </div>
                </>
            )}

            {showPersonContact && (
                <>
                    <div className="rsvp-overlay" onClick={handleClose} />
                    <div className={`rsvp-popup ${closing ? "popup-close" : "popup-open"}`}>
                        <PersonContact data={data} contacts={contacts} onClose={handleClose} />
                    </div>
                </>
            )}

            {showLocation && (
                <>
                    <div className="rsvp-overlay" onClick={handleClose} />
                    <div className={`rsvp-popup ${closing ? "popup-close" : "popup-open"}`}>
                        <EventLocation data={data} onClose={handleClose} />
                    </div>
                </>
            )}

            {showCalendar && (
                <>
                    <div className="rsvp-overlay" onClick={handleClose} />
                    <div className={`rsvp-popup ${closing ? "popup-close" : "popup-open"}`}>
                        <EventCalendar data={data} onClose={handleClose} />
                    </div>
                </>
            )}

            {showQRBank && (
                <>
                    <div className="rsvp-overlay" onClick={handleClose} />
                    <div className={`rsvp-popup ${closing ? "popup-close" : "popup-open"}`}>
                        <GiftSection data={data} onClose={handleClose} gifts={gifts} onGiftReserved={onGiftReserved} />
                    </div>
                </>
            )}


        </>
    );
};

export default CardBottomNav;
